/**
 * Quick Review worklist page for urology exception-flow orgs.
 *
 * Surfaces PA orders whose monitored fields drifted after re-ingestion so
 * reviewers can triage them from a dedicated board table.
 * @module quickReviewOrders
 */
import QuickReviewModals from "./components/quickReviewModals/quickReviewModals";
import QuickReviewOrdersTable from "./quickReviewOrdersTable";

/**
 * Layout shell for the Quick Review worklist.
 *
 * @returns Page header and scrollable table container
 */
const QuickReviewOrders = () => {
  return (
    <div className="quick-review-orders--main-container flex h-full flex-col overflow-hidden">
      <div className="quick-review-orders__header mb-4 text-h11 font-bold text-primaryGray-1">
        Quick Review Orders
      </div>
      <div className="quick-review-orders__table-container flex-1 overflow-auto">
        <QuickReviewOrdersTable />
      </div>
      <QuickReviewModals />
    </div>
  );
};

export default QuickReviewOrders;
